<template>
    <div>
        <div class="mt-5 centerLoadingBar" v-if="isLoading">
            <b-spinner type="grow" label="Spinning"></b-spinner>
        </div>
        <div v-else class="divCenter">
            <h4 class="mb-3">Größen Einstellungen</h4>



            <form>
                <hr>
                <p class="mt-2 lead">Größen bearbeiten</p>
                <div>
                    <div>
                        <b-dropdown :text="selectedSize ? selectedSize.name : 'Größe auswählen'"
                                    class="m-md-2 hl-dropdown">
                            <b-dropdown-item-button @click="sizeSelectionChanged(item)" :key="item.name + index"
                                                    v-for="(item, index) in sizes">{{item.name}}
                            </b-dropdown-item-button>
                        </b-dropdown>
                        <button class=" float-right  btn btn-dark mt-4 m-md-2" v-b-tooltip.hover
                                v-b-modal.modal-new-material title="Neue Größe hinzufügen">
                            <b-icon icon="plus-circle-fill"></b-icon>
                        </button>
                        <b-modal hide-footer id="modal-new-material" size="xl" title="Neue Größe hinzufügen">
                            <b-container fluid>

                                <b-row class="my-1">
                                    <b-col sm="4">
                                        <label for="newSizeName">Name</label>
                                    </b-col>
                                    <b-col sm="8">
                                        <b-form-input v-model="newSize.name" id="newSizeName" size="sm" type="text"/>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="4">
                                        <label for="newSizeDescription">Beschreibung</label>
                                    </b-col>
                                    <b-col sm="8">
                                        <b-form-input v-model="newSize.description" id="newSizeDescription" size="sm"
                                                      type="text"/>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="4">
                                        <label for="newSizeType">Typ</label>
                                    </b-col>
                                    <b-col sm="8">
                                        <b-dropdown :text="selectedTypeText" class="m-md-2 hl-dropdown">
                                            <b-dropdown-item-button @click="typeSelectionChanged(item)" :key="item.key"
                                                                    v-for="item in sizeTypes">{{item.label}}
                                            </b-dropdown-item-button>
                                        </b-dropdown>
                                    </b-col>
                                </b-row>


                            </b-container>

                            <button class="w-25  btn btn-dark mt-4 m-md-2" @click.prevent="createNewSizeItem">
                                Größen-Tabelle Anlegen
                            </button>

                        </b-modal>


                    </div>

                    <b-container v-if="selectedSize" fluid>


                        <b-row class="my-1">
                            <b-col sm="4">
                                <label for="sizeName">Name</label>
                            </b-col>
                            <b-col sm="8">
                                <b-form-input v-model="selectedSize.name" id="sizeName" size="sm" type="text"/>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="4">
                                <label for="sizeDescription">Beschreibung</label>
                            </b-col>
                            <b-col sm="8">
                                <b-form-input v-model="selectedSize.description" id="sizeDescription" size="sm"
                                              type="text"/>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="4">
                                <label for="sizeDescription">Typ</label>
                            </b-col>
                            <b-col sm="8">
                                <b-form-input v-model="selectedSize.type" id="sizeDescription" size="sm" type="text"/>
                            </b-col>
                        </b-row>
                        <div class="mt-5">


                            <!--                        <b-row v-if="selectedSize.type==='size'" class="my-1">-->
                            <div v-for="sizeItem in selectedSize.sizes" :key="sizeItem.model">
                                <b-row class="my-1">
                                    <b-col v-if="selectedSize.type==='size' || selectedSize.type==='size-color' " sm="4">
                                        <b-form-input v-model="sizeItem.size" id="sizeDescription" size="sm"
                                                      type="text"/>
                                    </b-col>
                                    <b-col v-if="selectedSize.type==='color' || selectedSize.type==='size-color' " sm="4">
                                        <b-form-input v-model="sizeItem.color" id="colorDescription" size="sm"
                                                      type="text"/>
                                    </b-col>
                                    <b-col sm="2">
                                        <b-form-input v-model="sizeItem.height" id="sizeDescription" size="sm"
                                                      type="text"/>
                                    </b-col>
                                    <b-col sm="2">
                                        <b-form-input v-model="sizeItem.width" id="sizeDescription" size="sm"
                                                      type="text"/>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                        <!--
                                               </b-row>-->

                        <div class="mt-5">
                            <b-form-file
                                    v-model="file"
                                    :state="Boolean(file)"
                                    placeholder="Größen hinzufügen (.xlsx .csv)"
                                    @change="fileUploaded"
                                    drop-placeholder="Drop file here..."
                            ></b-form-file>
                            <button @click.prevent="addSizesToSelectedMaterial" v-if="file" class="btn btn-dark mt-1" v-b-tooltip.hover title="Hochladen">
                                Hochladen
                            </button>
                        </div>
                    </b-container>




                    <!--                    <div class="mt-3" v-if="selectedMaterial._id">-->

                    <!--                        <MaterialData :selected-material="selectedMaterial"/>-->

                    <!--                    </div>-->

                </div>


                <!--                <button v-if="selectedMaterial._id" class="w-25  btn btn-dark mt-4 m-md-2" @click.prevent="saveData">Aktualisieren</button>-->
                <!--                <button v-if="selectedMaterial._id" class="w-25  btn btn-dark mt-4 m-md-2" @click.prevent="downloadParentFile">Parent Vorlage herunterladen</button>-->

            </form>
        </div>
    </div>


</template>


<script>

    import Api from './api'
    import XLSX from 'xlsx'

    export default {
        data() {
            return {
                file: undefined,
                fileJSON: [],
                isLoading: false,
                newSize: {},
                sizes: [],
                selectedSize: undefined,
                selectedTypeText: "Typ auswählen",
                sizeTypes: [
                    {
                        key: 'size',
                        label: "Größe"

                    },
                    {
                        key: 'color',
                        label: "Farbe"
                    },
                    {
                        key: 'size-color',
                        label: "Farbe & Größe"
                    }
                ]
            }
        },
        methods: {

            addSizesToSelectedMaterial(){
                let that = this
                let newObj = JSON.parse(JSON.stringify(this.selectedSize))
                // debugger//eslint-disable-line no-debugger
                newObj.sizes = this.fileJSON
                Api.upload_sizes.addNewSizesToExisting(newObj)
                    .then(res => {
                        if(res.status === 201){
                            that.makeToast('success', "Einträge erfolgreich hinzugefügt", "Erfolgreich hochgeladen")
                            that.loadSizes()
                        }
                    })

            },

            renameColumns(jsonString){
                // debugger//eslint-disable-line no-debugger
                let that = this
                let newObject = JSON.parse(jsonString).map(item => {
                    let keys = Object.keys(item)
                    switch (that.selectedSize.type) {
                        case 'size':
                            return {"size": item[keys[0]], height: item[keys[1]], width: item[keys[2]]}
                        case 'color':
                            return {"color": item[keys[0]], height: item[keys[1]], width: item[keys[2]]}
                        case 'size-color':
                            return {"size": item[keys[0]], "color": item[keys[1]],  height: item[keys[2]], width: item[keys[3]]}
                    }
                })
                return newObject
            },

            fileUploaded(e) {
                try {
                    let file = e.currentTarget.files ? e.currentTarget.files[0] : e.dataTransfer.files[0];
                    if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls") && !file.name.endsWith(".xlsm") && !file.name.endsWith(".csv")) {
                        throw new Error("Falsches format! Erwartet: .xlsx .xls .xlsm .csv")
                    }
                    let that = this
                    let reader = new FileReader();
                    reader.addEventListener("load", e => {
                        try {
                            let workbook = XLSX.read(e.target.result, {type: 'binary'})
                            workbook.SheetNames.forEach(function (sheetName) {
                                var XL_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
                                var json_object = JSON.stringify(XL_row_object);
                                that.fileJSON = that.renameColumns(json_object)
                                that.makeToast('success', "Datei erfolgreich gelesen.\n" + that.fileJSON.length + " Einträge vorhanden", "Erfolgreich gelesen")
                            })
                        } catch (e) {
                            this.makeToast('danger', e.message ? e.message : "Fehler", "Fehler beim Lesen")
                        }
                    });
                    reader.readAsBinaryString(file)
                } catch (e) {
                    this.makeToast('danger', e.message ? e.message : "Fehler", "Fehler beim Lesen")
                }
            },

            makeToast(variant = null, body = '', title = '') {
                this.$bvToast.toast(body, {
                    title: title,
                    variant: variant,
                    solid: true
                })
            },

            createNewSizeItem() {
                let that = this;
                Api.upload_sizes.createNewSize(this.newSize)
                    .then(res => {
                        if(res.status === 201){
                            this.makeToast('success', 'Größe erstellt', 'Größe erstellt')
                            that.newSize = {}
                            that.loadSizes();

                        }
                    })
                    .catch(e => {
                        this.makeToast('danger', e.message, 'Fehler beim Erstellen')
                    })
            },
            sizeSelectionChanged(selectedItem) {
                this.selectedSize = selectedItem
            },
            typeSelectionChanged(selectedItem) {

                this.newSize.type = selectedItem.key
                this.selectedTypeText = selectedItem.label

            },
            uploadSize(event) {
                console.log(event)
            },

            async loadSizes() {
                Api.upload_sizes.getAllSizes()
                    .then(res => res.data)
                    .then(sizes => {

                        this.sizes = sizes
                        if(this.selectedSize){
                            this.selectedSize = sizes.filter(item => item._id === this.selectedSize._id)
                        }
                    })
            }


        }
        ,
        beforeMount() {
            console.warn("Before mount")
            let jwt = this.$cookies.get("authToken")
            // console.log(jwt)

            var that = this
            Api.auth.verify({authToken: jwt})

                .then(response => {
                    if (response.status == 200) {
                        this.$store.commit('setUser', true);
                        Api.init(jwt);

                        that.loadSizes()

                    }
                })
                .catch(() => {
                    this.$store.commit('setUser', false)
                    this.$router.push({path: '/'})
                })
        }

    }
</script>

<style>
    .hl-dropdown {
        width: 200px;
    }

    .divCenter {
        padding-top: 20px;
        margin-left: 20%;
        margin-right: 20%;
    }

</style>
